import { ScrollToCurrent } from './ScrollToCurrent';

export default ScrollToCurrent;
